const formatPhoneNumber = (str) => {
	if (!str) {
		return ''
	}
	return str.replace(/\d*?(\d{3})(\d{3})(\d{3})$/, '$1 $2 $3')
}
export default formatPhoneNumber
